import React, { Component } from 'react';
import FileInput from 'react-fine-uploader/file-input';
import Typography from '@material-ui/core/Typography';

import PropTypes from 'prop-types';

const styles = {
  button: {
    position: 'absolute',
    width: 110,
    margin: 5,
    backgroundColor: '#fefefe',
    borderRadius: 5,
    padding: 5,
    textAlign: 'center',
    borderWidth: 1,
    borderColor: '#cccccc',
    borderStyle: 'solid',
    cursor: 'pointer',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
  },
};

class UploadButton extends Component {

  render() {
    const container = {
      display: 'flex',
      // marginRight: 20,
      flexDirection: 'row',
      alignItems: 'center',
      cursor: 'pointer',
    };

    return (
      // <div style={this.props.styles}>
      <FileInput multiple accept="image/*" uploader={this.props.uploader}>
        <div style={container}>
          {this.props.icon}
          <Typography style={this.props.typographyStyle}>{this.props.title}</Typography>
        </div>
      </FileInput>
      // </div>
    );
  }
}

UploadButton.propTypes = {
  uploader: PropTypes.object,
  title: PropTypes.string,
  styles: PropTypes.object,
  icon: PropTypes.object,
  typographyStyle: PropTypes.object,
};

UploadButton.defaultProps = {
  uploader: null,
  styles: null,
  icon: null,
  typographyStyle: null,
  title: '',
};

export default UploadButton;



// WEBPACK FOOTER //
// ./src/app/components/uploader/upload-button.js